function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import WKTWriter from '../../io/WKTWriter';
import Coordinate from '../../geom/Coordinate';
import Double from '../../../../../java/lang/Double';
import Comparator from '../../../../../java/util/Comparator';
var IntervalRTreeNode = /*#__PURE__*/function () {
  function IntervalRTreeNode() {
    _classCallCheck(this, IntervalRTreeNode);
    IntervalRTreeNode.constructor_.apply(this, arguments);
  }
  return _createClass(IntervalRTreeNode, [{
    key: "getMin",
    value: function getMin() {
      return this._min;
    }
  }, {
    key: "intersects",
    value: function intersects(queryMin, queryMax) {
      if (this._min > queryMax || this._max < queryMin) return false;
      return true;
    }
  }, {
    key: "getMax",
    value: function getMax() {
      return this._max;
    }
  }, {
    key: "toString",
    value: function toString() {
      return WKTWriter.toLineString(new Coordinate(this._min, 0), new Coordinate(this._max, 0));
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IntervalRTreeNode;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { IntervalRTreeNode as default };
var NodeComparator = /*#__PURE__*/function () {
  function NodeComparator() {
    _classCallCheck(this, NodeComparator);
    NodeComparator.constructor_.apply(this, arguments);
  }
  return _createClass(NodeComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var n1 = o1;
      var n2 = o2;
      var mid1 = (n1._min + n1._max) / 2;
      var mid2 = (n2._min + n2._max) / 2;
      if (mid1 < mid2) return -1;
      if (mid1 > mid2) return 1;
      return 0;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return NodeComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
}();
NodeComparator.constructor_ = function () {};
IntervalRTreeNode.NodeComparator = NodeComparator;
IntervalRTreeNode.constructor_ = function () {
  this._min = Double.POSITIVE_INFINITY;
  this._max = Double.NEGATIVE_INFINITY;
};